import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LaiseeService from '@/service/laisee';
import { getUrlParam } from '@tencent/vft-common/util';
import { initUserState } from '@vip-activity/business';
import { isToday } from '@/util/helper';
import popShare from './pop-share/pop-share.vue';
import popConfirm from './pop-confirm/pop-confirm.vue';
import popFinish from './pop-packet-finish/pop-packet-finish.vue';
import popOpen from './pop-open/pop-open.vue';
import popSuccess from './pop-success/pop-success.vue';
export default {
  components: {
    popShare: popShare,
    popConfirm: popConfirm,
    popFinish: popFinish,
    popOpen: popOpen,
    popSuccess: popSuccess
  },
  data: function data() {
    return {
      // 展示控制
      showConfirm: false,
      showPacketResultPop: false,
      // 领取结果
      showPacketOpenPop: false,
      // 准备领取
      showPacketFinishPop: false,
      // 已经领取,过期,限次
      showDangerPop: false,
      laiseeInfo: null,
      laiseeStatus: {
        isFetched: false,
        isFinish: false,
        isExpired: false,
        // 领取次数是否达到上限
        isTotalLimit: false,
        isDayLimit: false
      },
      // 红包
      laisee: null,
      // 红包类型
      vipType: 'hvip',
      contentType: 'day',
      // 红包内容
      day: 0,
      price: '',
      // 优惠券过期时间
      expireDate: null,
      // 逻辑处理完成
      done: false,
      showPopShare: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return initUserState();

            case 2:
              _this.checkLaiseeReceived();

              _this.eventBus.$on('openShare', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        console.log('分享弹层');
                        _this.showPopShare = true;

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    /**
     *  判断该url是否是领取红包
     */
    checkLaiseeReceived: function checkLaiseeReceived() {
      // 获得红包id
      var ptag = getUrlParam('ptag');
      var laiseeId = getUrlParam('laisee_id'); // 口令分享的ptag会覆盖为passwordshare

      if (['share_laisee', 'share_laiseeimg', 'passwordshare'].includes(ptag) && laiseeId) {
        console.log('可以领取红包');
        this.setState({
          state: 'receivedLaisee',
          value: laiseeId
        });
        this.checkLaisee();
      } else if (this.tenvideoVuid === '') {
        // 不是从主站过来的
        this.$emit('laiseeFinish');
      }
    },
    checkLaisee: function checkLaisee() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return LaiseeService.getInfo(_this2.receivedLaisee);

              case 3:
                _this2.laiseeInfo = _context3.sent;
                _context3.next = 12;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                console.error(_context3.t0);

                _this2.toast('获取红包信息失败');

                _this2.$emit('laiseeFinish');

                return _context3.abrupt("return");

              case 12:
                _this2.setState({
                  state: 'isOwner',
                  value: !!_this2.laiseeInfo.owner
                });

                _this2.laiseeStatus = {
                  isFetched: _this2.laiseeInfo.fetch_result === 1,
                  // 是否已经抢过
                  isFinish: _this2.laiseeInfo.used >= _this2.laiseeInfo.total,
                  // 是否已领完
                  isExpired: !isToday(_this2.laiseeInfo.ctime) // 是否已过期（即不是今天的红包）

                };

                _this2.loading.hide();

                if (!Object.values(_this2.laiseeStatus).includes(true)) {
                  _context3.next = 19;
                  break;
                }

                _this2.showPacketFinishPop = true; // 已经抢完或者过期

                if (!_this2.test) {
                  // 删除红包信息;
                  _this2.delUrlParams('laisee_id');
                }

                return _context3.abrupt("return");

              case 19:
                // 准备领取红包
                _this2.showPacketOpenPop = true;

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 6]]);
      }))();
    },
    normalFetch: function normalFetch() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.showConfirm = false;

                _this3.loading.show(); // 领取红包


                _context4.next = 4;
                return _this3.fetchLaisee();

              case 4:
                if (_context4.sent) {
                  _context4.next = 7;
                  break;
                }

                _this3.loading.hide();

                return _context4.abrupt("return");

              case 7:
                if (!_this3.test) {
                  // 删除红包信息;
                  _this3.delUrlParams('laisee_id');
                } // 获取红包类型


                _this3.setLaiseeType(); // 设置领取信息


                _this3.setFetchInfo();

                if (!Object.values(_this3.laiseeStatus).includes(true)) {
                  _context4.next = 15;
                  break;
                }

                _this3.loading.hide();

                _this3.showPacketFinishPop = true; // 已经抢完或者过期
                // 删除红包信息;

                _this3.delUrlParams('laisee_id');

                return _context4.abrupt("return");

              case 15:
                if (!_this3.isOwner) {
                  _context4.next = 19;
                  break;
                }

                _this3.updateFetcherList();

                _context4.next = 19;
                return _this3.checkLaiseeFinish();

              case 19:
                _this3.loading.hide(); // 显示弹层


                _this3.showPacketResultPop = true;

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },

    /**
     * 领取红包
     */
    fetchLaisee: function fetchLaisee() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return LaiseeService.fetchLaisee({
                  laiseeId: _this4.receivedLaisee,
                  head: _this4.userService.headurl,
                  nick: _this4.userService.nick
                });

              case 3:
                _this4.laisee = _context5.sent;
                _context5.next = 10;
                break;

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);

                _this4.handleFetchLaiseeError(_context5.t0);

                return _context5.abrupt("return", false);

              case 10:
                return _context5.abrupt("return", true);

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[0, 6]]);
      }))();
    },
    popReady: function popReady() {
      this.loading.hide(); // 展示领取结果弹窗

      this.done = true;

      if (!this.test) {
        // 删除红包信息;
        this.delUrlParams('laisee_id');
      }

      this.showPacketFinishPop = true; // 已经抢完或者过期

      this.showPacketOpenPop = false;
    },

    /**
     * 设置红包类型
     */
    setLaiseeType: function setLaiseeType() {
      var _this$checkLaiseeType = this.checkLaiseeType(this.laisee.type),
          vip = _this$checkLaiseeType.vip,
          content = _this$checkLaiseeType.content;

      this.vipType = vip;
      this.contentType = content;
    },

    /**
     * 设置领取信息
     */
    setFetchInfo: function setFetchInfo() {
      // 设置 isGet 以及红包领取结果
      var res = this.laisee.fetch_result; // 已经领完

      if (res === 2) {
        this.laiseeStatus.isFinish = true;
        return;
      } // 已经过期


      if (res === 3 || res === 5) {
        this.laiseeStatus.isExpired = true;
        return;
      } // 天数红包


      if (this.contentType === 'day') {
        this.day = this.laisee.content;
        return;
      } // 黑产优惠券，显示过期时间


      this.price = this.laisee.money / 100;
      this.expireDate = this.laisee.expiretime * 1000;
    },

    /**
     * 红包是否领完
     */
    checkLaiseeFinish: function checkLaiseeFinish() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var info;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                info = null;
                _context6.prev = 1;
                _context6.next = 4;
                return LaiseeService.getInfo(_this5.receivedLaisee);

              case 4:
                info = _context6.sent;
                _context6.next = 12;
                break;

              case 7:
                _context6.prev = 7;
                _context6.t0 = _context6["catch"](1);
                console.error(_context6.t0);

                _this5.toast('获取红包信息失败');

                return _context6.abrupt("return");

              case 12:
                // 已经领完了
                if (info.used >= info.total) {
                  _this5.laiseeStatus.isFinish = true;
                }

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[1, 7]]);
      }))();
    },

    /**
     * 领取红包接口错误处理
     */
    handleFetchLaiseeError: function handleFetchLaiseeError(e) {
      var _this6 = this;

      console.debug('fetchLaisee', JSON.parse(JSON.stringify(e)));
      var code = e.code; // 达到每日领取次数上限

      if ([-10003001, -10003004].includes(code)) {
        this.laiseeStatus.isDayLimit = true;
        this.popReady();
        return;
      } // 达到活动领取次数上限


      if ([-10003002, -10003003, -10003005, -10003006, 10028].includes(code)) {
        // case -10002005:
        this.laiseeStatus.isTotalLimit = true;
        this.popReady();
        return;
      } // 过期


      if (code === -10002009) {
        this.laiseeStatus.isExpired = true;
        this.popReady();
        return;
      } // 登录态问题


      if ([// 未登录
      -102, -11, // 登录态校验错误
      -9901, -10001, -10002].includes(code)) {
        this.toast('登录状态出问题啦，请重新登录');
        setTimeout(function () {
          _this6.loginService.openLogin();
        }, 500);
        return;
      } // server timeout 一种情况是红杏发货失败


      if (code === -10001005) {
        this.toast('红包走丢啦，刷新试试吧');
        return;
      } // 黑产


      if (code === 101) {
        // this.toast('您的账号存在风险，请切换账号后重试');
        this.$emit('showDanger');
        return;
      } // 小号 102 104


      if (code > 0) {
        this.shieldRun(JSON.parse(e.res.result.secInfo), function () {
          _this6.normalFetch();
        });
        return;
      } // 兜底


      this.toast("\u554A\u54E6\uFF0C\u548C\u6D3B\u52A8\u5931\u53BB\u8054\u7CFB\uFF0C\u5237\u65B0\u8BD5\u8BD5\u5427\uFF01(".concat(code, ")"));
    },

    /**
     * 翻译红包type字段，获得会员类型和红包类型
     * @param {Number} type 红包类型 1: hvip天数, 4: hvip优惠券, 6:svip天数, 7:svip优惠券
     */
    checkLaiseeType: function checkLaiseeType(type) {
      var res = {
        vip: 'hvip',
        content: 'day'
      };

      if ([6, 7].includes(type)) {
        res.vip = 'svip';
      }

      if ([4, 7].includes(type)) {
        res.content = 'coupon';
      }

      return res;
    }
  }
};